<template>
  <div class="fillcontain">
    <search-item @showDialog="showAddDialog"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
      >
        <el-table-column
          v-if="idFlag"
          prop="id"
          label="id"
          align="left"
        ></el-table-column>
        <!-- <el-table-column prop="type" label="自定义条目" align="left"></el-table-column> -->
        <el-table-column
          prop="coursePackageId"
          label="课包类型"
          align="left"
          :filters="this.coursePackageData"
          :filter-method="filterCoursePackage"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCoursePackage(scope.row)"
              disable-transitions
              >{{ scope.row.coursePackageId }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="activeName" label="活动名称" align="left">
        </el-table-column>
        <el-table-column
          prop="classHour"
          label="课时数"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="buyTime"
          label="课包购买时间"
          align="left"
          sortable
        >
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{ scope.row.buyTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="beginTime"
          label="课包开启时间"
          align="left"
          sortable
        >
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{ scope.row.beginTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="classHoursDDL"
          label="课包截止时间"
          align="left"
          sortable
        >
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{ scope.row.classHoursDDL }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width=""
          prop="isUse"
          label="是否过期"
          align="left"
          :filters="fields.memberStatus.filter.list"
          :filter-method="filterMemberStatus"
          filter-placement="bottom-end"
          :filtered-value="[true]"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterMemberStatus(scope.row)"
              :type="scope.row.isUse == false ? 'danger' : 'success'"
              disable-transitions
              >{{ scope.row.isUse }}</el-tag
            >
          </template>
        </el-table-column>
         <el-table-column
          width=""
          prop="isDone"
          label="是否完结"
          align="left"
          :filters="[{text: '已完结', value: 1}, {text: '未完结', value: 0}]"
          :filter-method="filterDoneStatus"
          filter-placement="bottom-end"
          :filtered-value="[0]"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.isDone === 1 ? 'danger' : 'success'"
              disable-transitions
              >{{ scope.row.isDone === 1 ? '已完结': (scope.row.isDone === 0 ? '未完结' : '')}}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="notes"
          label="备注"
          align="left"
        ></el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDelete(scope.row, scope.$index)"
              >删除</el-button
            >
            <el-button
              v-show="ROLE == 1"
              type="warning"
              icon="edit"
              size="mini"
              @click="onEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-show="ROLE == 1"
              type="warning"
              icon="edit"
              size="mini"
              @click="onTransfer(scope.row)"
              >转让</el-button
            >
            <el-button
              v-show="ROLE == 1"
              type="warning"
              icon="edit"
              size="mini"
              @click="onCourseDelay(scope.row)"
              >课包延期</el-button
            >
            <el-button
              v-show="ROLE == 1"
              type="warning"
              icon="edit"
              size="mini"
              @click="finishPackage(scope.row)"
              >完结</el-button
            >
            <el-button
              v-show="ROLE == 1"
              type="primary"
              icon="edit"
              size="mini"
              @click="unfinishPackage(scope.row)"
              >未完结</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <AddMemberCoursePackageDialog
        v-if="addDialog.show"
        :isShow="addDialog.show"
        :dialogRow="addDialog.dialogRow"
        :username="addDialog.username"
        :name="addDialog.name"
        :coursePackageList="addDialog.coursePackageList"
        :formatCoursePackageList="addDialog.formatCoursePackageList"
        @getClassHourList="getMemberCoursePackageList"
        @closeDialog="hideAddDialog"
      ></AddMemberCoursePackageDialog>
      <AddTransferClassHourDialog
        v-if="addTransfer.show"
        :isShow="addTransfer.show"
        :dialogRow="addTransfer.dialogRow"
        :telephone="this.user.telephone"
        :username="addDialog.username"
        :buytime="addDialog.buytime"
        :coursePackageList="addDialog.coursePackageList"
        :formatCoursePackageList="addDialog.formatCoursePackageList"
        @getClassHourList="getMemberCoursePackageList"
        @closeDialog="hideAddTransferDialog"
      >
      </AddTransferClassHourDialog>
    </div>
    <el-dialog title="课包延期" :visible.sync="delayDialogVisible" width="30%">
      <el-form :inline="true" :model="delayForm" class="demo-form-inline">
        <el-form-item label="天数">
          <el-input
            v-model="delayForm.dayNum"
            placeholder="请输入天数"
          ></el-input>
        </el-form-item>
        <el-form-item label="截止日期">
          <el-date-picker v-model="delayForm.beginTime" type="datetime" placeholder="请选择日期" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delayDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDelayDate"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddMemberCoursePackageDialog from "./components/addMemberCoursePackageDialog";
import AddTransferClassHourDialog from "./components/addTransferClassHour";
import { formatDateTime } from "../../utils/date.js";
import Pagination from "@/components/pagination";
import { getFormatCoursePackages } from "@/api/coursepackage";
import {
  getCoursePackageAndMemberListByUsername,
  deleteCoursePackageAndMember,
  changeMemberCoursePackageClasshourDDLById,
  doneMemberCoursePackage,
  unDoneMemberCoursePackage
} from "@/api/memberCoursePackage";
import { getToken } from "@/utils/auth";
import { addOperationRecord } from "@/api/operationrecord";

export default {
  data() {
    return {
      //延期课包对话框
      delayDialogVisible: false,
      delayForm:{
        dayNum:'',
        beginTime:''
      },
      rowData:{},
      addTransfer: {
        show: false,
        dialogRow: {},
      },
      tableData: [],
      coursePackageData: [],
      format_course_package_list: {},
      tableHeight: 0,
      loading: false,
      ROLE: 0,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      sortnum: 0,
      addDialog: {
        show: false,
        dialogRow: {},
        username: "oEOcg5bNsAsEb-7ue4QuoY-vGQwY",
        coursePackageList: {},
        formatCoursePackageList: {},
        buytime: "",
      },
      format_member_status_list: {
        false: "已过期",
        true: "未过期",
      },
      studentData: {
        page: 1,
        limit: 100,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {
        memberStatus: {
          filter: {
            list: [
              {
                text: "已过期",
                value: false,
              },
              {
                text: "未过期",
                value: true,
              },
            ],
          },
        },
      },
    };
  },
  components: {
    SearchItem,
    AddMemberCoursePackageDialog,
    AddTransferClassHourDialog,
    Pagination,
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
  },
  created() {
    this.ROLE = getToken("ROLE");
  },
  mounted() {
    this.addDialog.username = this.user.username;
    this.addDialog.name = this.user.name;
    this.getFormatCoursePackagesList();
    this.getMemberCoursePackageList();
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    filterMemberStatus(value, item) {
      const type = item.isUse;
      return (
        this.format_member_status_list[value] ==
        this.format_member_status_list[type]
      );
    },
    formatterMemberStatus(item) {
      const type = item.isUse;
      return this.format_member_status_list[type];
    },
    // 编辑操作方法
    onEdit(row) {
      this.addDialog.dialogRow = { ...row };
      this.showAddDialog();
    },
    // 课时转让
    onTransfer(row) {
      this.addTransfer.dialogRow = { ...row };
      this.addDialog.buytime = row.buyTime;
      this.showAddTransferDialog();
      console.log("onTransfer:", this.addTransfer.show);
    },
    getFormatCoursePackagesList() {
      console.log("getFormatCoursePackagesList");
      getFormatCoursePackages({}).then((res) => {
        console.log(res);
        this.coursePackageData = res.data.data.coursePackageData;
        this.format_course_package_list =
          res.data.data.format_course_package_list;
        var coursePackageData = {
          coursePackageList: this.coursePackageData,
        };
        this.addDialog.coursePackageList = coursePackageData;
        this.addDialog.formatCoursePackageList = {
          formatCoursePackageList: this.format_course_package_list,
        };
      });
    },
    //获取课时账单列表数据
    getMemberCoursePackageList() {
      //   const para = this.classhourSpendData;
      var username = this.user.username;
      getCoursePackageAndMemberListByUsername(username).then((res) => {
        this.tableData = [];
        console.log(res);
        this.loading = false;
        if (res.data.code == 200) {
          this.tableData = res.data.data.coursePackageAndMemberDatas;
        }
      });
    },
    // 显示资金弹框
    showAddDialog(val) {
      this.$store.commit("SET_CLASSHOUR_DIALOG_TITLE", val);
      this.addDialog.show = true;
    },
    showAddTransferDialog() {
      this.addTransfer.show = true;
    },
    hideAddDialog() {
      this.addDialog.show = false;
    },
    hideAddTransferDialog() {
      this.addTransfer.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.classhourSpendData.page = val - 1;
      this.getMemberCoursePackageList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.classhourSpendData.limit = val;
      this.getMemberCoursePackageList();
    },
    /**
     * 格式化状态
     */
    formatterCoursePackage(item) {
      const type = parseInt(item.coursePackageId);
      return this.format_course_package_list[type];
    },
    filterCoursePackage(value, item) {
      const type = parseInt(item.coursePackageId);
      return (
        this.format_course_package_list[value] ==
        this.format_course_package_list[type]
      );
    },
    // 编辑操作方法
    onEditStudent(row) {
      //   this.$router.push({ path: "/memberManage/fundList" });
      this.addEventDialog.dialogRow = { ...row };
      this.showAddEventDialog();
    },
    // 删除数据
    onDelete(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { id: row.id };
          console.log(para);
          deleteCoursePackageAndMember(row.id).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              const para = {
                userName: getToken("USERNAME"),
                content:
                  "删除(" +
                  this.user.name +
                  ")会员课包操作,课包类型为:" +
                  this.format_course_package_list[
                    parseInt(row.coursePackageId)
                  ] +
                  ",课包购买时间为:" +
                  row.buyTime,
              };
              addOperationRecord(para).then((res) => {
                console.log(res);
              });
              this.getMemberCoursePackageList();
            } else {
              this.$message({
                message: "删除失败",
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    onCourseDelay(row) {
      this.delayDialogVisible = true;
      this.rowData = row
      console.log(row, '数据行');
    },
    submitDelayDate() {
      console.log(this.delayForm,'提交数据',this.rowData);
      if(this.delayForm.dayNum !== '' &&this.delayForm.beginTime!== ''){
          changeMemberCoursePackageClasshourDDLById({...this.delayForm,id:this.rowData.id}).then(res => {
          this.$message({
            message: "延期成功",
            type: "success",
          });
          this.delayForm = {dayNum:'',beginTime:''}
          this.delayDialogVisible = false;
          this.getFormatCoursePackagesList();
          this.getMemberCoursePackageList();
        })
      }else {
        this.$message({
          message: "请填写必要信息",
          type: "error",
        });
      }
    },
    filterDoneStatus(value, row, column) {
      return row['isDone'] === value;
    },
    finishPackage(row) {
      this.$confirm("确认完结课包?", "提示", {
        type: "warning",
      })
        .then(() => {
          console.log('确认完结课包',row);
          doneMemberCoursePackage({id: row.id}).then(res => {
            this.$message({
              message: "完结成功",
              type: "success",
            });
            this.getFormatCoursePackagesList();
            this.getMemberCoursePackageList();
          })
        })
        .catch(() => {});
    },
    unfinishPackage(row) {
      this.$confirm("确认未完结课包?", "提示", {
        type: "warning",
      })
        .then(() => {
          console.log('确认未完结课包',row);
          unDoneMemberCoursePackage({id: row.id}).then(res => {
            this.$message({
            message: "未完结成功",
            type: "success",
            });
            this.getFormatCoursePackagesList();
            this.getMemberCoursePackageList();
          })
        })
        .catch(() => {});
    }
  },
};
</script>


<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>